import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loyalty-point',
  templateUrl: './loyalty-point.component.html',
  styleUrls: ['./loyalty-point.component.scss'],
})
export class LoyaltyPointComponent implements OnInit {
  @Input() value: number;
  @Input() cssClass: string;
  @Input() showTrophy: boolean;
  constructor() { }

  ngOnInit() {}

}
